var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container mt-4"},[_c('section',[(_vm.me)?_c('withdrawal-account',{attrs:{"me":_vm.me}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }